

const getInputs = () => {
  return []
}

export default getInputs
